export enum WorkersSectionsEnum {
  Workers = 'workers',
  ContractorCompanies = 'companies',
  Approved = 'approved',
}
